import { Chip } from "@mui/material"
import React from "react"
import { customPalette } from "../../../theme"
import { BSVariantStatusEnum, bsVariantStatusToLabel } from "../../core/dto/beem-shot/BSVariant/BSVariantStatusEnum"
import { DefaultTypography } from "../typography/default-typography"

interface IProps {
  status: BSVariantStatusEnum | undefined
  clickable?: boolean
}

export function BSVariantStatusChip({ status, clickable = false }: Readonly<IProps>): React.JSX.Element {
  function getStatusBackgroundColor(): string {
    switch (status) {
      case BSVariantStatusEnum.IN_PROGRESS:
        return customPalette.lightBlue3
      case BSVariantStatusEnum.DELETED:
        return customPalette.orangishWhite
      default:
        return ""
    }
  }

  function getTypologyColor(): string {
    switch (status) {
      case BSVariantStatusEnum.DELETED:
        return customPalette.orange2
      case BSVariantStatusEnum.IN_PROGRESS:
        return customPalette.mediumBlue1
      default:
        return ""
    }
  }

  return (
    <Chip
      sx={{
        backgroundColor: getStatusBackgroundColor(),
        color: getTypologyColor(),
        height: "auto",
        minHeight: "unset",
        cursor: clickable ? "pointer" : undefined,
        "& .MuiChip-label": {
          px: 1,
        },
      }}
      label={
        <DefaultTypography
          label={bsVariantStatusToLabel(status)}
          fontSize="11px"
          lineHeight="16px"
          fontWeight={500}
          color={getTypologyColor()}
        />
      }
    />
  )
}
